const KEY = 'csrfToken';

export function getAntiForgeryToken() {
  const token = sessionStorage.getItem(KEY);
  if (token) {
    return token;
  }
  return null;
}

export function setAntiForgeryToken(token) {
  if (token) {
    sessionStorage.setItem(KEY, token);
  }
}
